export default "__VITE_ASSET__BnGwXzNz__"